<template>
  <v-list>
    <v-list-tile
      v-for="item in items"
      :key="item.value"
    >
      <v-list-tile-content>
        <v-btn
          flat large block
          class="item-btn"
          @click="setLocale(item)"
        >
          {{ item.text }}
        </v-btn>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  name: 'LanguageList',
  data () {
    return {
      items: [
        { text: '日本語', value: 'ja' },
        { text: 'English', value: 'en' },
        { text: '簡体中文', value: 'zh' },
        { text: '繁體中文', value: 'zhtw' },
        { text: '한국어', value: 'ko' }
      ]
    }
  },
  methods: {
    setLocale (item) {
      this.$storage.set('locale', item.value)
      this.$i18n.locale = item.value
    }
  }
}
</script>

<style scoped>
.item-btn {
  text-transform: none;
}
</style>
